/**
 * 语音翻译模块共用常量
 * 语言展示名由 cr_language 接口 / 观众端 init 返回
 */

/**
 * 单会话在前端保留的翻译片段条数上限（观众端 / 主讲端输出区等共用）。
 * 与 vh 布局无关：前者只控制「一屏裁切」，本上限防止长会议 SSE 堆积导致 DOM/内存过大。
 */
export const MAX_DISPLAY_LINES = 50
